<template>
  <div class="answer">
    <img :src="questionDetail.questionBackground " alt="" />
    <div class="content" v-if="questions.length">
      <template v-if="questionDetail.answerTime != 'no'">
        <div class="time-title">时间</div>
        <div class="time">00 : {{questionDetail.limitTime | limitTime}}</div>
      </template>
      <div class="subject-box">
        <span class="title">第{{currentIndex+1}}题，共{{questions.length}}题</span>
        <span class="subject">{{currentQuesion.questionTitle}}</span>
      </div>
      <div class="answer-box">
        <div class="answer" v-for="(item, index) in currentQuesion.answers" :key="index">
          <div class="icon-img">{{ index | letter }}</div>
          <div
            class="text"
            :style="{ background: `url(${bck})`, backgroundSize: '100% 100%' }"
          >
            {{item.answerContext}}
          </div>
        </div>
      </div>
      <div class="button-box">
        <van-button type="primary" class="button" size="small" @click="upDownQuestion(-1)">上一题</van-button>
        <van-button type="primary" class="button" size="small" @click="upDownQuestion(1)">下一题</van-button>
        <van-button type="primary" class="button" size="small" @click="goBack">返回</van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      img: "https://img3.quanyou.com.cn/joy/group1/M00/14/D4/rB4ChWL1sLKACl2OABQSmSUdhLw379.png",
      bck: "https://img3.quanyou.com.cn/joy/group1/M00/14/D4/rB4ChmL1vuaAIFcpAAA_BRGOr_w640.png",
      questions: [],
      currentQuesion: {},
      currentIndex: 0,
      questionDetail: {},
    };
  },
  computed: {
    from() {
      return this.$route.query.from;
    },
    activityId() {
      return this.$route.query.activityId || "";
    }
  },
  methods: {
    // 获取试题配置详细
    queryActivityQuestion() {
      this.$api.question.queryActivityQuestion(this.activityId).then(res => {
        if (res.success && res.data) {
          this.questionDetail = res.data
          this.questions = res.data.questions
          this.currentQuesion = res.data.questions[0]
        }
      })
    },
    upDownQuestion(number) {
      if (number == 1 && this.currentIndex == this.questions.length -1) {
        this.$toast("没有下一题了")
        return
      }
      if (number == -1 && this.currentIndex === 0) {
        this.$toast("没有上一题了")
        return
      }
      this.currentIndex = this.currentIndex + number
      this.currentQuesion = this.questions[this.currentIndex]
    },
    goBack() {
      this.$router.go(-1)
    },
  },
  mounted() {
    this.queryActivityQuestion()
  },
  filters: {
    limitTime(time) {
      return (time+'').length < 2 ? '0'+time : time
    },
    letter(index) {
      let map = {
        0: "A",
        1: "B",
        2: "C",
        3: "D",
      };
      return map[index];
    },
  },
};
</script>

<style lang="stylus" scoped>
.answer {
  height 100%
  overflow hidden
  font-size 0
  img {
    width 100%
    height auto
  }
  .content {
    position: fixed;
    top: 60px;
    left: 25px;
    right: 25px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .time-title {
      font-size: 23px;
      color: #FFC928;
    }
    .time {
      color: #FFC928;
      font-size: 26px;
      font-weight: 400;
      margin-top: 11px;
    }
    .subject-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 20px;
      .title {
        font-size: 17px
        color: #E1282D;
        font-weight: 400;
      }
      .subject {
        font-size: 25px;
        color: #FFFFFF;
        font-weight: 400;
        margin-top: 12px;
      }

    }
    .answer-box {
      margin-top: 28px;
      .answer {
        display: flex;
        width: 100%;
        font-size: 20px;
        color: #FFFFFF;
        margin-top: 15px;
        .icon-img {
          font-size: 22px;
          color: #E1282D;
          width: 41px;
          height: 41px;
          font-weight: 600;
          text-align: center;
          line-height: 41px;
          border-radius: 50%;
          background: url('https://img3.quanyou.com.cn/joy/group1/M00/14/D3/rB4ChmL1tqGAS1eMAAAXInTSK5U254.png');
          background-size: 100% 100%;
        }
        .text {
          font-size: 20px;
          color: #E1282D;
          width: 276px;
          height: 46px;
          text-align: center;
          line-height: 46px;
          font-weight: 600;
          margin-left: 13px;

        }
      }
    }
    .button-box {
      width: 100%;
      display: flex;
      justify-content: space-around;
      margin-top: 35px;
      .button {
        width: 80px;
      }
    }
  }
}
</style>
